export const FEATURE_FLAGS = {
  LOYALTY_ENABLED: 'is_loyalty_enabled',
  LOYALTY_USER_RESERVATIONS: 'enable_loyalty_user_reservations',
  FEATURED_ITEMS: 'enable_featured_items',
  SHOW_INVENTORY_PAGE: 'show_inventory_page',
};

export function isPublicFeatureFlagEnabled(flags, key) {
  const list = Array.isArray(flags) ? flags : flags?.data;
  if (!Array.isArray(list)) {
    return false;
  }

  const flag = list.find((item) => item.key === key);
  if (!flag) {
    return false;
  }

  return Boolean(flag.enabled ?? flag.value);
}

/** Normalize API payloads into a flat feature-flag array. */
export function normalizeFeatureFlags(raw) {
  if (!raw) {
    return [];
  }

  if (Array.isArray(raw)) {
    return raw;
  }

  if (Array.isArray(raw.data)) {
    return raw.data;
  }

  return [];
}
